import create from 'zustand'
import shallow from 'zustand/shallow'
import { useEffect } from 'react'

const [useUiStore] = create((set, get) => ({
  showInfo: true,
  setShowInfo: (showInfo) => set({ showInfo }),
  toggleShowInfo: () =>
    set((state) => ({ showInfo: !state.showInfo }))
}))

/**
 * Hook for showInfo state with toggle and set functions
 * @param {*} initialValue
 */
export const useShowInfo = (initialValue) => {
  const [show, toggle, set] = useUiStore(
    (state) => [
      state.showInfo,
      state.toggleShowInfo,
      state.setShowInfo
    ],
    shallow
  )
  useEffect(
    () =>
      typeof initialValue !== undefined &&
      set(initialValue),
    [initialValue, set]
  )
  return [show, toggle, set]
}

export default useUiStore
